module.exports = __webpack_public_path__ + "img/1579177079.db493cbc.jpg";